document.querySelectorAll('[data-hn-bundle59]').forEach((root) => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const preview = root.querySelector('[data-bundle-preview]');
  const dialog = root.querySelector('dialog');
  const reader = dialog.querySelector('.hn-bundle59__reader');
  const fullImage = reader.querySelector('img');
  const zoom = dialog.querySelector('[data-bundle-zoom]');
  let opener;
  preview.addEventListener('toggle', () => {
    if (!preview.open) return;
    preview.querySelectorAll('img[data-src]').forEach((image) => {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    });
  });
  root.querySelectorAll('[data-bundle-page]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!dialog.showModal || event.ctrlKey || event.metaKey || event.shiftKey) return;
      event.preventDefault();
      opener = link;
      fullImage.src = link.href;
      fullImage.alt = link.querySelector('img').alt;
      dialog.querySelector('h2').textContent = link.dataset.pageTitle;
      dialog.querySelector('[data-bundle-original]').href = link.href;
      reader.removeAttribute('data-full-size');
      zoom.setAttribute('aria-pressed', 'false');
      dialog.showModal();
      reader.scrollTop = 0;
      reader.scrollLeft = 0;
    });
  });
  dialog.querySelector('[data-bundle-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus({preventScroll: true}));
  zoom.addEventListener('click', () => {
    reader.setAttribute('data-full-size', '');
    zoom.setAttribute('aria-pressed', 'true');
  });
  dialog.querySelector('[data-bundle-fit]').addEventListener('click', () => {
    reader.removeAttribute('data-full-size');
    zoom.setAttribute('aria-pressed', 'false');
    reader.scrollTop = 0;
    reader.scrollLeft = 0;
  });
});
